import { render, staticRenderFns } from "./ChannelGrid.vue?vue&type=template&id=e95049f4&scoped=true"
import script from "./ChannelGrid.vue?vue&type=script&lang=js"
export * from "./ChannelGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95049f4",
  null
  
)

export default component.exports